import styled from 'styled-components';

export const StyledPaymentMethod = styled.div`
    width: 100%;
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    &:last-child {
        margin: 0;
    }
    button {
        background: 'white';
        cursor: pointer;
        color: white;
        height: 50px;
        font-size: 18px;
        border: 0;
        outline: 0;
        border-radius: 7px;
        letter-spacing: 0.8px;
        width: 100%;
    }
` as any;
